import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Redirect, withRouter} from 'react-router';

import {Link} from 'components/ReactRouterDomLocalized';

import {login} from 'backend-helpers/member';

import {t} from 'l10n';

import {logout, setCurrentUser, LOGIN_SUCCESS} from 'reducers/currentUser';

// todo: make 'form' Node module
import {Form, InputWrapper, ErrorContainer} from 'form';
import {getCookie, setCookie} from "../../../utils/cookie";
import {compose} from "redux";
import EditIcon from "../../icon/Edit";
import paths from '../../../paths';
import ExitIcon from "../../icon/Exit";

class ModalMenuLoginForm extends Component {
    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
        this.onLoginSuccess = this.onLoginSuccess.bind(this);
    }

    onSubmit(formData, setErrors) {
        let {currentUser, location} = this.props;
        login(formData).then(this.onLoginSuccess).catch(function(error) {
            //console.log('ModalMenuLoginForm onError', error);

            if (typeof error === 'string') {
                setErrors(error);
            } else {
                if(error.message !== "Network Error")
                    setErrors(t(error.message));
                else 
                    setErrors(t('Unknown Error'));
            }
        });
    }

    onLoginSuccess({user, token}) {
        let {dispatch, location, history} = this.props;

        // todo: make an action creator?
        // todo: move redirect logic to middleware?

        //--

        let VISITED = getCookie('VISITED') || '';
        if (typeof window !== 'undefined' && user.age_verified === 0) {
            document.body.style.paddingRight = '30px'
            document.querySelector('.modalDisclaimer').style.paddingRight = '30px'

            try {
                //@ts-ignore
                window.ageverif.start();

            } catch (e) {
                console.error('AgeVerify initialization error:', e);
            }
            setTimeout(() => {
                document.body.style.paddingRight = '15px'
                document.querySelector('.modalDisclaimer').style.paddingRight = '15px'
            }, 1)
        } else {
            if (user.age_verified === 1 && !VISITED) {
                let entries = VISITED.split(',').filter((entry) => entry != '');
                entries.push('/disclaimer/');

                setCookie('VISITED', entries.join(','), 86400);
                if (this.props.setDisclaimer) this.props.setDisclaimer(true)
            }
        }
        const returnPath = new URLSearchParams(location.search).get('return_path');
        if (returnPath && window) {
            window.location.replace(returnPath);
        } else {
                history.push(location.pathname);
            }

        // --

        dispatch({type: LOGIN_SUCCESS, user, token});
        if (this.props.onLogin) {
            this.props.onLogin();
        }
    }

    render() {
        let { currentUser } = this.props;
        let { ageverif = false } = this.props;
        const { dispatch } = this.props;

        return (
            <p>
                {ageverif && currentUser.nick ? (
                    <div className='userInfo'>
                        <p className="account">
                            <span className="user-avatar">
                                <Link to={paths.member.path}><img src={currentUser.avatar_url} alt=""/></Link>
                            </span>
                                <Link to={paths.member.path} className="nick">
                                    {currentUser.nick}
                                </Link>
                                <span className="icons-wrapper">
                                {/*<Link to={paths.member.path} className="profile-edit">*/}
                                {/*    <EditIcon colorIndex="theme"/>*/}
                                {/*</Link>*/}
                                <span className="logout" onClick={() => {
                                    dispatch(logout())
                                }}><ExitIcon colorIndex="theme"/></span>
                            </span>
                        </p>
                    </div>
                ) : (
                    <p className="name">
                        <span>{t('Log in')}</span>
                        {currentUser.exists() && !currentUser.isActive()
                            ? <Link to="/?confirm_registration" className="header-button">{t('Activate')}</Link>
                            : <Link to="/?register" className="header-button">{t('Sign up')}</Link>
                        }
                    </p>
                )}
                <p>
                    {ageverif &&
                        <span style={{color: 'white', textWrap: 'wrap', display: 'block', width: '300px'}}>Veuillez ressaisir votre mot de passe pour valider votre identité.</span>}
                </p>
                <Form onSubmit={this.onSubmit}>
                    <ErrorContainer data-errorcontainer={true}/>

                    <div className="space-between">
                        <InputWrapper
                            data-formfield={true}
                            name="nick" type="text"
                            placeholder={t('Nick')}
                            defaultValue={currentUser && currentUser.nick ? currentUser.nick : ''}
                            disabled={currentUser && currentUser.nick}
                            style={{color: currentUser && currentUser.nick ? 'grey' : 'unset'}}
                        />
                    </div>
                    <div>
                    <InputWrapper data-formfield={true} name="password" type="password"
                                      placeholder={t('Password')}/>
                    </div>
                    <div>
                        <div className="right-text">
                            {currentUser.exists() && !currentUser.isActive() &&
                                <a style={{float: 'left', cursor: 'pointer'}} onClick={() => dispatch(logout())}>{t('Log out')}</a>
                            }
                            <Link to="/?password_recover" className="header-button">{t('Forgot password?')}</Link>
                        </div>
                    </div>
                    <div>
                        <button type='submit' className="btn-submit">{t('Enter')}</button>
                    </div>
                </Form>
            </p>
        )
    }
}

export default
    connect(state => ({
        currentUser: state.currentUser
    }))(withRouter(ModalMenuLoginForm));


// WEBPACK FOOTER //
// ./src/components/modals/ModalMenu/ModalMenuLoginForm.js